import { Box, Grid, Paper, Typography } from "@mui/material";
import { PageContainer } from "../App/Components/PageContainer/PageContainer";
import { PageTitle } from "../App/Components/PageTitle/PageTitle";
import { Reports } from "./Components/Reports/Reports";
import { QuotaAlerts } from "./Components/QuotaAlerts/QuotaAlerts";
import DateRangePicker from "../App/Components/DateRange/DateRangePicker";
import { useState } from "react";

function Dashboard(props: { userHasAccess: boolean }) {
  const [endDate, setEndDate] = useState<Date>(new Date());
  const [startDate, setStartDate] = useState<Date>(new Date());

  return (
    <PageContainer>
      {props.userHasAccess ? (
        <>
          <QuotaAlerts />
          <Paper sx={{ mt: { xs: 1, md: 4 }, p: { xs: 2, lg: 4 }, mb: 2 }}>
            <Grid container>
              <Grid item md={6} lg={9}>
                <PageTitle>Dashboard</PageTitle>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <DateRangePicker
                  id="dashboard-report-dates"
                  startDate={startDate}
                  endDate={endDate}
                  handleSetStartDate={(d) => {
                    if (d) setStartDate(new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0));
                  }}
                  handleSetEndDate={(d) => {
                    if (d) setEndDate(new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59));
                  }}
                />
              </Grid>
            </Grid>
          </Paper>
          <Reports startDate={startDate} endDate={endDate} />
        </>
      ) : (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontFamily: "h1.fontFamily",
              color: "error.main",
              fontWeight: 700,
              fontSize: "3rem",
            }}
            data-test="noAccessMessage"
          >
            YOU ARE NOT ASSIGNED TO ANY CRM CLIENTS
          </Typography>
        </Box>
      )}
    </PageContainer>
  );
}

export default Dashboard;
